import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {TSMap} from 'typescript-map';
import {TextMessage} from '../model/email/TextMessage';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {Message} from '../model/microsite/message';
import {ExternalLink} from '../model/social-sharing/externalLink';

@JsonConverter
export class ExternalLinkConverter implements JsonCustomConvert<ExternalLink> {

    deserialize(json: any): ExternalLink {

        // const msgArr = new Array<TextMessage>();
        return Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json,ExternalLink);
        /*const temp:TSMap<string,string>= new TSMap();
        for (const key of Object.keys(json)) {
            temp.set(key, json[key]);
        }

        return temp;*/
    }

    serialize(data: ExternalLink): any {
        return JSON.stringify(data);
    }
}
